import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import { constants } from 'cng-web-lib'
import UaeMpciKeys from 'src/constants/locale/key/UaeMpci'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate, documentType) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )

  const errMsgAlphaNumericWithSpecialChar = translate(
    Namespace.UAE_MPCI,
    UaeMpciKeys.ValidationMessage.ERROR_MSG_ALPHA_NUMERIC_WITH_SPECIAL_CHAR
  )

  const errMsgNumeric = translate(
    Namespace.UAE_MPCI,
    UaeMpciKeys.ValidationMessage.ERROR_MSG_NUMERIC
  )

  const errMsgMaxLength = translate(
    Namespace.UAE_MPCI,
    UaeMpciKeys.ValidationMessage.ERROR_MSG_MAX_LENGTH
  )

  const regexNumeric = '^[0-9]*$'
  const regexAlphaNumericWithSpecialChar =
    '^[a-zA-Z0-9 ,+\\-$#@%&()!\'`^_:;.?\\[\\]\\{\\}\\/="\\|\\\\ ]+$'

  return Yup.object({
    billNo: Yup.string().nullable(),
    parentBillNo: Yup.string().nullable(),
    containerNumber: Yup.string().nullable().required(requiredMessage).max(17, errMsgMaxLength + " 17"),
    goodsItemNumber: Yup.string().nullable().required(requiredMessage).max(6, errMsgMaxLength + " 6"),
    totalPackageQuantity: Yup.string().nullable().required(requiredMessage).matches(regexNumeric, errMsgNumeric).max(8, errMsgMaxLength + " 8"),
    packageTypeDescription: Yup.string().nullable().required(requiredMessage),
    goodsItemGrossWeight: Yup.string().nullable().required(requiredMessage).max(18, errMsgMaxLength + " 18"),
    grossWeightUnitCode: Yup.string().nullable().required(requiredMessage),
    hsCode: documentType === '705'
      ? Yup.string().nullable().required(requiredMessage).max(18, errMsgMaxLength + " 18")
      : Yup.string().nullable().max(18, errMsgMaxLength + " 18"),
    goodsItemDescription: documentType === '705'
      ? Yup.string().nullable().required(requiredMessage).matches(regexAlphaNumericWithSpecialChar, errMsgAlphaNumericWithSpecialChar).max(2560, errMsgMaxLength + " 2560")
      : Yup.string().nullable().matches(regexAlphaNumericWithSpecialChar, errMsgAlphaNumericWithSpecialChar).max(2560, errMsgMaxLength + " 2560"),
    additionalInfo: Yup.string().nullable().matches(regexAlphaNumericWithSpecialChar, errMsgAlphaNumericWithSpecialChar).max(512, errMsgMaxLength + " 512"),
    packageType: Yup.string().nullable().max(35, errMsgMaxLength + " 35"),
    packingDescription: Yup.string().nullable(),
    handlingInstructionCode: Yup.string().nullable(),
    handlingInstructionDesc: Yup.string().nullable().matches(regexAlphaNumericWithSpecialChar, errMsgAlphaNumericWithSpecialChar).max(512, errMsgMaxLength + " 512"),
    goodsItemNetWeight: Yup.string().nullable().max(18, errMsgMaxLength + " 18"),
    netWeightUnitCode: Yup.string().nullable(),
    volume: Yup.string().nullable().max(18, errMsgMaxLength + " 18"),
    volumeUnitCode: Yup.string().nullable(),
    packingInstructionsCode: Yup.string().nullable(),
    marksAndLabels: Yup.string().nullable().max(35, errMsgMaxLength + " 35"),
    countryOfOrigin: Yup.string().nullable().max(2, errMsgMaxLength + " 2"),
    locationName: Yup.string().nullable().matches(regexAlphaNumericWithSpecialChar, errMsgAlphaNumericWithSpecialChar).max(256, errMsgMaxLength + " 256"),
    dgHazardClassCodes: Yup.string().nullable().test('dg-hazard-required', requiredMessage, function(val) {
      const { undgIdentifier, dgFlashpointDesc, shipmentFlashpointDegree, flashpointUnitCode, packagingDangerLevelCode } = this.parent
      const hasDgData = [undgIdentifier, dgFlashpointDesc, shipmentFlashpointDegree, flashpointUnitCode, packagingDangerLevelCode].some(v => !!v)
      return !hasDgData || !!val
    }),
    undgIdentifier: Yup.string().nullable().matches(regexNumeric, errMsgNumeric).max(4, errMsgMaxLength + " 4").test('undg-required', requiredMessage, function(val) {
      const { dgHazardClassCodes, dgFlashpointDesc, shipmentFlashpointDegree, flashpointUnitCode, packagingDangerLevelCode } = this.parent
      const hasDgData = [dgHazardClassCodes, dgFlashpointDesc, shipmentFlashpointDegree, flashpointUnitCode, packagingDangerLevelCode].some(v => !!v)
      return !hasDgData || !!val
    }),
    dgFlashpointDesc: Yup.string().nullable().max(8, errMsgMaxLength + " 8"),
    shipmentFlashpointDegree: Yup.string().nullable().max(3, errMsgMaxLength + " 3"),
    flashpointUnitCode: Yup.string().nullable(),
    packagingDangerLevelCode: Yup.string().nullable(),
    doesPackageToBeSplit: Yup.string().nullable().required(requiredMessage),
  })
}

export default makeValidationSchema
